// Vendor Libs
import React, {useContext} from 'react';
import PropTypes from 'prop-types';

// Material UI
import {makeStyles} from '@material-ui/core/styles';

// Contexts
import {LayoutContext} from '../../../contexts/layout-context';

const useStyles = makeStyles(theme => ({
  root: {
    borderColor: theme.palette.grey[200],
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(3),
    },
    transition: theme.transitions.create(['margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
}));

const Footer = ({children}) => {
  const classes = useStyles();
  const {navVariant, navWidth, collapsible, collapsed, collapsedWidth, footerShrink, open, navAnchor} = useContext(
    LayoutContext
  );
  const getMargin = () => {
    if (navAnchor !== 'left' || !footerShrink) return 0;
    if ((navVariant === 'persistent' && open) || navVariant === 'permanent') {
      if (collapsible) {
        if (collapsed) return collapsedWidth;
        return navWidth;
      }
      return navWidth;
    }
    return 0;
  };

  return (
    <div
      className={classes.root}
      style={{
        marginLeft: getMargin(),
      }}
    >
      {children}
    </div>
  );
};

Footer.propTypes = {
  children: PropTypes.node,
};

export default Footer;
